import { useAuthenticationInternal } from '@pflegenavi/frontend/authentication';
import { useServiceProvider } from '@pflegenavi/service-provider-frontend/api';
import { getGlobalServiceProviderIdFromToken } from '../utils/getGlobalServiceProviderIdFromToken';

export const useGetCountryOfServiceProvider = (): string | undefined => {
  const { getTokenImmediate } = useAuthenticationInternal();

  const globalServiceProviderId = getGlobalServiceProviderIdFromToken(
    getTokenImmediate()
  );

  const { data: serviceProvider } = useServiceProvider({
    globalServiceProviderId,
  });

  return serviceProvider?.countryId;
};
